import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { apiConfig } from "../../config";
import { IGetProductDetailsParams } from "./interfaces/api-product-details-interface";
import {
  IProductsGetAllParams,
  IProductsSearchParams,
} from "./interfaces/api-product-interfaces";
import ApiProducts from "./product-api";
import { getKey } from "../../common-interfaces/quiries-keys/queries-keys";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";

export const useProduct = () => new ApiProducts(apiConfig());
export const useGetAllProductsQuery = ({
  params,
  enabled = true,
}: {
  params: IProductsGetAllParams | any;
  enabled?: boolean;
}) => {
  const product = useProduct();
  return useQuery(
    [
      ...getKey(Keys.getAllProducts),
      Object.keys(params),
      Object.values(params),
    ],
    () => product.getProducts({ ...params }),
    {
      refetchOnWindowFocus: true,
      enabled: enabled,
    }
  );
};
export const useGetAllProductsInfiniteQuery = ({
  params,
  enabled = true,
}: {
  params: IProductsGetAllParams | any;
  enabled?: boolean;
}) => {
  const product = useProduct();
  return useInfiniteQuery(
    [
      ...getKey(Keys.getAllProducts),
      Object.keys(params),
      Object.values(params),
      "InfiniteQuery",
    ],
    ({ pageParam = { ...params, page: 1 } }) => product.getProducts(pageParam),
    {
      getNextPageParam: (lastPage) => {
        const nextPage = lastPage.result.meta.current_page + 1;
        const totalPages = lastPage.result.meta.last_page;
        return nextPage <= totalPages ? { ...params, page: nextPage } : null;
      },
      enabled: enabled,
    }
  );
};
export const useGetProductDetailsQuery = ({
  params,
}: {
  params: IGetProductDetailsParams;
}) => {
  const product = useProduct();
  return useQuery(
    [...getKey(Keys.getProductDetails), Object.values(params)],
    () => product.getProductDetails({ ...params }),
    {
      refetchOnWindowFocus: true,
      enabled: !!params.id,
    }
  );
};
export const useSearchProductsQuery = ({
  params,
}: {
  params: IProductsSearchParams;
}) => {
  const product = useProduct();
  return useQuery(
    [...getKey(Keys.searchProducts), , Object.values(params)],
    () => product.searchProducts({ ...params }),
    {
      refetchOnWindowFocus: true,
      enabled: !!params.q.trim(),
    }
  );
};
